<app-impersonation-bar [testId]="'platform-impersonation-bar'" />

<router-outlet />
